// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import { AnimatedCheckmark } from 'components/Icon';
import TabContext from 'containers/TabContext';
import { colors, transition } from '../theme';

const Label = styled.label.attrs(({ checked }) => ({
  style: {
    transform: checked ? 'translateX(26px) translateZ(0)' : 'translateZ(0)'
  }
}))`
  transition: transform ${transition};
`;

const Input = styled.input`
  width: 100%;
  height: 100%;
  margin: 0;
  appearance: none;
  ${props =>
    !props.isTabbing &&
    `
    &:focus {
      outline: 0;
    }
  `}
`;

const CheckmarkContainer = styled.div`
  position: absolute;
  left: 24px;
  top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  pointer-events: none;
`;

const Container = styled.div.attrs(({ checked }) => ({
  style: {
    background: checked ? colors.waterBlue : colors.platinum,
    color: checked ? 'white' : colors.oceanBlue
  }
}))`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 60px;
  padding: 7px 48px 7px 30px;
  border-radius: 30px;
  transition: all ${transition};
  * {
    cursor: pointer;
  }
  &:hover {
    background: ${colors.waterBlue} !important;
    color: white !important;
  }
`;

const LargeCheckbox = ({
  id,
  name,
  label,
  checked,
  hasError,
  onChange,
  ...props
}: {
  id?: string,
  name?: string,
  label: React.Node,
  checked: boolean,
  hasError?: boolean,
  onChange: boolean => void
}) => (
  <Container checked={checked}>
    <Box top={0} left={0} position="absolute" width={1} height="100%">
      <TabContext.Consumer>
        {isTabbing => (
          <Input
            type="checkbox"
            name={name}
            id={id}
            checked={checked}
            onChange={e => {
              e.stopPropagation();
              onChange(e.target.checked);
            }}
            isTabbing={isTabbing}
            {...props}
          />
        )}
      </TabContext.Consumer>
    </Box>
    <CheckmarkContainer checked={checked}>
      {checked && (
        <AnimatedCheckmark
          width={14}
          height={14}
          stroke="white"
          strokeWidth="2px"
          opacity={0.7}
          delay={0}
          $duration={0.3}
        />
      )}
    </CheckmarkContainer>
    <Box
      component={Label}
      pointerEvents="none"
      htmlFor={id}
      checked={checked}
      lineHeight={1.375}
      fontSize={18}
    >
      {label}
    </Box>
  </Container>
);

export default LargeCheckbox;
